import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import { Tooltip } from '@instinet-analytics/core-lib';
import { getBenchmarkTooltip } from 'widgets/estimatedTradeCost/components/options';

export default function benchmarkCellRenderer({ data }: ICellRendererParams) {
    const benchmark: string = data.benchmark;

    return (
        <Tooltip text={getBenchmarkTootip(benchmark)} showDelay={0}>
            <div className={`${getBenchmarkClass(benchmark)}`}>
                {getBenchmarkText(benchmark)}
            </div>
        </Tooltip>
    );
}

function getBenchmarkTootip(benchmark: string) {
    return getBenchmarkTooltip(benchmark);
}

function getBenchmarkClass(benchmark: string) {
    return `benchmark benchmark-${benchmark}`;
}

function getBenchmarkText(benchmark: string) {
    return benchmark.substring(0, 4).toUpperCase();
}
